import * as Types from '../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type MirrorCardQueryVariables = {
  idCard: Types.Scalars['ID'];
};


export type MirrorCardQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'name'>
    & { board: (
      { __typename: 'Board' }
      & Pick<Types.Board, 'id' | 'name'>
    ), list: (
      { __typename: 'List' }
      & Pick<Types.List, 'id' | 'name'>
    ) }
  )> }
);


export const MirrorCardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MirrorCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}]};

/**
 * __useMirrorCardQuery__
 *
 * To run a query within a React component, call `useMirrorCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMirrorCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMirrorCardQuery({
 *   variables: {
 *      idCard: // value for 'idCard'
 *   },
 * });
 */
export function useMirrorCardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MirrorCardQuery, MirrorCardQueryVariables>) {
        return ApolloReactHooks.useQuery<MirrorCardQuery, MirrorCardQueryVariables>(MirrorCardDocument, baseOptions);
      }
export function useMirrorCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MirrorCardQuery, MirrorCardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MirrorCardQuery, MirrorCardQueryVariables>(MirrorCardDocument, baseOptions);
        }
export type MirrorCardQueryHookResult = ReturnType<typeof useMirrorCardQuery>;
export type MirrorCardLazyQueryHookResult = ReturnType<typeof useMirrorCardLazyQuery>;
export type MirrorCardQueryResult = ApolloReactCommon.QueryResult<MirrorCardQuery, MirrorCardQueryVariables>;